import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { AuthModule } from './auth/auth.module';
import { GlobalErrorHandler } from './errors/global-error/global-error-handler';
import { HttpErrorInterceptor } from './errors/http-error/http-error.interceptor';

@NgModule({
  imports: [
    CommonModule,
    AuthModule
  ],
  exports: [
    AuthModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
